const styles = {
  root: {
    // 114.4px is the result of height of header + spacer + padding-top of main layout
    height: 'calc(100vh - 114.4px)',
    display: 'flex',
    flexDirection: 'column',
  },
}

export default styles
